import api from "../../api.js";

export const getBranches = async () => {
  try {
    const response = await api.get("/api/users/branches");
    return response.data;
  } catch (err) {
    console.error("Error fetching branches:", err);
    throw err;
  }
};

export const getUsers = async (branchCode) => {
  try {
    const response = await api.get("/api/users/employees", { params: { branch: branchCode } });
    return response.data; 
  } catch (err) {
    console.error("Error fetching users for branch:", err);
    throw err;
  }
};

export const addUser = async (payload) => {
  try {
    const response = await api.post("/api/users/employees", payload);
    return response.data;
  } catch (err) {
    console.error("Error adding user:", err);
    throw err;
  }
};

export const getRoles = async () => {
  try {
    const response = await api.get("/api/users/roles");
    return response.data; // array of role names
  } catch (err) {
    console.error("Error fetching roles:", err);
    throw err;
  }
};

export const getRolesDetailed = async () => {
  try {
    const response = await api.get("/api/users/roles-detailed");
    return response.data; // array of { roleid, rolename }
  } catch (err) {
    console.error("Error fetching roles (detailed):", err);
    throw err;
  }
};

export const getUserByEmail = async (email) => {
  try {
    const response = await api.get(`/api/users/employees/${encodeURIComponent(email)}`);
    return response.data;
  } catch (err) {
    console.error("Error fetching user by email:", err);
    throw err;
  }
};

export const updateUser = async (email, payload) => {
  try {
    const response = await api.put(`/api/users/employees/${encodeURIComponent(email)}`, payload);
    return response.data;
  } catch (err) {
    console.error("Error updating user:", err);
    throw err;
  }
};

export const getUserByEmployeeNumber = async (employeeNumber) => {
  try {
    const response = await api.get(
      `/api/users/employees/by-employee-number/${encodeURIComponent(employeeNumber)}`
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching user by employee number:", err);
    throw err;
  }
};

export const updateUserByEmployeeNumber = async (employeeNumber, payload) => {
  try {
    const response = await api.put(
      `/api/users/employees/by-employee-number/${encodeURIComponent(employeeNumber)}`,
      payload
    );
    return response.data;
  } catch (err) {
    console.error("Error updating user by employee number:", err);
    throw err;
  }
};

export const toggleUserActive = async (email, isActive) => {
  try {
    const response = await api.patch(`/api/users/employees/${encodeURIComponent(email)}/toggle`, { isActive });
    return response.data;
  } catch (err) {
    console.error("Error toggling user active:", err);
    throw err;
  }
};

export const previewFrontShopCode = async () => {
  try {
    const res = await api.get("/api/users/frontshopcode/preview");
    return res.data?.code || "";
  } catch (err) {
    console.error("Error previewing front shop code:", err);
    return "";
  }
};

export const getFrontShopPins = async () => {
  try {
    const res = await api.get("/api/users/frontshop/pins");
    const pins = res.data?.pins;
    return Array.isArray(pins) ? pins : [];
  } catch (err) {
    console.error("Error fetching front shop PINs:", err);
    return [];
  }
};

export const frontshopLogin = async (frontshopcode) => {
  try {
    const response = await api.post("/frontshop-login", { frontshopcode });
    return response.data;
  } catch (err) {
    console.error("Error during frontshop login:", err);
    throw err;
  }
};

// Upload via server (multipart), returns URL or key
export const uploadUserDoc = async (employee_number, file) => {
  const form = new FormData();
  form.append("employee_number", employee_number);
  form.append("file", file);
  const res = await api.post(`/api/users/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = res.data || {};
  return data.viewUrl || data.location || data.key || null;
};

export const uploadMyProfilePicture = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await api.post(`/api/users/profile-picture`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = res.data || {};
  return {
    key: data.key || null,
    profilePicUrl: data.profilePicUrl || null,
  };
};

export const deleteMyProfilePicture = async () => {
  const res = await api.delete(`/api/users/profile-picture`);
  return res.data || {};
};